module.exports = __webpack_public_path__ + "static/media/3.60b2d8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/九宫格未选中态/3.png
// module id = 1064
// module chunks = 0